import React from 'react'

export const SplitView = ({ children }) => (
  <div className="kiosk-container">{children}</div>
)

export const LeftPanel = ({ children }) => (
  <div className="w-full md:w-1/3 h-full mt-2.5">{children}</div>
)

export const RightPanel = ({ children }) => (
  <div className="w-full md:w-2/3 h-full">{children}</div>
)
